import { useModuleBEM } from "@b2bportal/core-themes";
import {
  HotelDetailsReviewSection,
  HotelPriceBreakdownReviewSection,
} from "../../../../components";
import styles from "./styles.module.scss";

export const HotelsBookingSummaryContent = () => {
  const [block, cn] = useModuleBEM(styles, "HotelsBookingSummaryContent");

  return (
    <div className={block}>
      <HotelDetailsReviewSection className={cn("section")} />

      <HotelPriceBreakdownReviewSection className={cn("section")} />
    </div>
  );
};
